
import { defineComponent, PropType } from 'vue'
import { mapGetters, mapState } from 'vuex'
import AsahiTabs from '@/components/library/AsahiTabs.vue'
import CustomButton from '@/components/library/AsahiBsCustomButton.vue'
import DropDown from '@/components/library/AsahiDropdown.vue'
import AsahiLogoNew from '@/components/library/assets/AsahiLogoNew.vue'
import AsahiProgressBar from '@/components/library/assets/AsahiProgressBar.vue'
import AsahiUserIconAlt from '@/components/library/assets/AsahiUserIconAlt.vue'
import AsahiSelect from '@/components/library/AsahiSelect.vue'
import locationwhite from '@/assets/icons/library/locationwhite.svg'
import locationgold from '@/assets/icons/library/locationgold.svg'
import AsahiFavoriteIconAlt from '@/components/library/assets/AsahiFavoriteIconAlt.vue'
import { Modal, Collapse } from 'bootstrap'
import LoaderSpinner from '@/components/common/LoaderSpinner.vue'
import { LinksActionType } from '@/store/modules/links/interfaces'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiBsSearchProducts from './AsahiBsSearchProducts.vue'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'
import AsahiBsSearchMarketingMaterials from './AsahiBsSearchMarketingMaterials.vue'
import AsahiBsSearchNewsAndArticles from './AsahiBsSearchNewsAndArticles.vue'
import AsahiBsSearchSupport from './AsahiBsSearchSupport.vue'
import { FilesActionType } from '@/store/modules/files/interfaces/action-type'
import { ArticlesActionType } from '@/store/modules/articles/interfaces/action-type'
import { SupportActionType } from '@/store/modules/support/interfaces/action-type'
import AsahiLoaderCard from './AsahiLoaderCard.vue'
import { constants } from '@/constants'

interface HeaderData {
  label: string;
  children: any[];
  name: string;
}

interface CartItem {
  id: string;
  product: {
    name: string;
    image: {
      url: string;
    };
    sku: number
    number_of_products_on_layer: number
  };
  quantity_total: number;
  number_of_layer: number,
  number_of_pallet: number

}

interface FooterLink {
  name: string,
  label: string
  href?: string
  link?: string
  target?: string
  isActive?: boolean
}

interface RoleDetail {
  rolename: string;
  roleid: string;
  permission: string;
  roleType: string;
  customerType: string;
  possibleRoles: string;
}

interface User {
  permissionSchema: { shipToAddress: any, companyName: string, shipToId: string }[];
}

export default defineComponent({
  name: 'AsahiBsNav',

  props: {
    headerData: {
      type: Object as PropType<HeaderData[]>,
      required: true
    },
    rightMenu: {
      type: Object,
      required: false
    },
    cartItem: {
      type: Array as PropType<CartItem[]>,
      required: true
    },
    favoriteItem: {
      type: Number,
      required: false
    },
    cartNumber: {
      type: Number
    },
    user: {
      type: Object as PropType<User>,
      required: true
    },
    catalogPermission: {
      type: Boolean
    }
  },
  mixins: [refreshAfterChangeLanguage],
  data () {
    return {
      showOnHover: true,
      locationgold,
      searchActive: false,
      tabs: [
        { name: 'products', label: this.$t('Products').toUpperCase(), component: AsahiBsSearchProducts },
        { name: 'marketing-materials', label: this.$t('Marketing Materials').toUpperCase(), component: AsahiBsSearchMarketingMaterials },
        { name: 'news-and-articles', label: this.$t('News and Articles').toUpperCase(), component: AsahiBsSearchNewsAndArticles },
        { name: 'support', label: this.$t('Support').toUpperCase(), component: AsahiBsSearchSupport }
      ],
      currentTab: 0,
      searchHistory: JSON.parse(sessionStorage.getItem('search_history') as string),
      locationwhite,
      openDropdown: false,
      searchTimer: 0,
      searchInputActive: false,
      showModal: false,
      openCart: false,
      loading: false,
      searchKeyword: '',
      searchValue: '',
      isLoading: false,
      CompanyName: localStorage.getItem('selectedCompanyName') || this.user?.permissionSchema?.[0]?.companyName
    }
  },
  components: {
    AsahiTypography,
    AsahiFavoriteIconAlt,
    AsahiUserIconAlt,
    AsahiLogoNew,
    AsahiProgressBar,
    AsahiTabs,
    AsahiLoaderCard,
    CustomButton,
    LoaderSpinner
    // DropDown,
    // AsahiSelect
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items', 'paymentMethod']),
    ...mapGetters('basket', ['progressBarMessage', 'progressBarSuccess', 'showProgressBarMessage']),
    ...mapState('catalog', ['alignment', 'products']),

    customerType () {
      const customerTypeArray = this.$store.state.auth.user.permissionSchema
        .filter(permission => permission?.rpDetails.some((item: RoleDetail) => item.customerType.toLowerCase() !== ''))
      return customerTypeArray ? customerTypeArray[0]?.rpDetails[0]?.customerType : ''
    },

    isOnTradeCustomer () {
      return this.customerType ? (this.customerType.toLowerCase() === 'ontrade') : false
    },

    visibleTabs () {
      return this.tabs.map(tab => {
        switch (tab.name) {
          case 'products':
            return { ...tab, isVisible: this.hasProductsData }
          case 'marketing-materials':
            return { ...tab, isVisible: this.hasMarketingMaterialsData }
          case 'news-and-articles':
            return { ...tab, isVisible: this.hasNewsData }
          case 'support':
            return { ...tab, isVisible: this.hasSupportData }
          default:
            return { ...tab, isVisible: true }
        }
      }).filter(tab => tab.isVisible)
    },

    filesStore () {
      return this.$store.state.files
    },

    hasProductsData () {
      return this.products.length > 0
    },
    hasMarketingMaterialsData () {
      const marketingMaterial = this.filesStore && this.filesStore.marketingMaterials && this.filesStore.marketingMaterials.results
      return marketingMaterial && marketingMaterial.length > 0
    },
    hasNewsData () {
      const newArticle = this.$store.state.articles.searchArticles && this.$store.state.articles.searchArticles.results
      return newArticle && newArticle.length > 0
    },
    hasSupportData () {
      const faqPages = this.$store.state.support.faqPages
      const kbsAsync = this.$store.state.support.newAllKbsAsync
      return (faqPages && faqPages.length > 0) || (kbsAsync && kbsAsync.length > 0)
    },

    isStandardOntrade ():boolean {
      return this.$store.state.auth.user?.permissionSchema?.[0]?.rpDetails[0]?.rolename === 'Ontrade Standard'
    },

    currentUser () {
      return this.$store.state.auth.user
    },
    isTruckAvailable () {
      return this.query && this.query.progress_bar_data && typeof this.query.progress_bar_data.isFullTruck !== 'undefined'
    },

    isTruck () {
      if (this.isTruckAvailable) {
        return this.query.progress_bar_data.isFullTruck
      }
      return false
    },
    getSelectedShipToDetails () {
      const shipToId = this.query.ship_to_id || localStorage.getItem('shipToId')
      const data = this.user.permissionSchema.filter((permission: any) => permission.shipToId === shipToId)
      return data
        ? {
            shipToId: data[0]?.shipToId,
            shipToName: data[0]?.companyName,
            shipToAddress: (data[0]?.shipToAddress)
          }
        : {}
    },
    shipToName () {
      const shipToId = this.query.ship_to_id || localStorage.getItem('shipToId')
      return this.user.permissionSchema.find((permission: any) => permission.shipToId === shipToId)
    },
    shipToList () {
      return this.user?.permissionSchema?.filter((permission: any) => permission.rpDetails.some((role: any) => role.permission.includes('Catalogue')))
        .map(item => ({
          label: item.companyName + ', ' + (item.shipToAddress).toLowerCase(),
          value: item.shipToId,
          text: item.companyName,
          longText: item.shipToAddress.toLowerCase()
        }))
    }

  },

  methods: {

    onTabChanged (tabIndex: number) {
      this.currentTab = tabIndex
    },

    onSearchOpen () {
      if (!this.searchActive) {
        this.searchActive = true
        this.initSearch()
      }
    },

    closeModal () {
      const menuModalNav = document.getElementById('searchModalNav')
      if (menuModalNav) {
        const modal = Modal.getInstance(menuModalNav) || new Modal(menuModalNav)
        if (modal) {
          modal.hide()
          this.searchActive = false
        }
      }
    },

    storeSearchHistory () {
      const searchHistoryStored = JSON.parse(sessionStorage.getItem('search_history') as string) || []
      searchHistoryStored.unshift(this.searchValue)
      const newSearchHistory = [...new Set(searchHistoryStored)]?.slice(0, 3)
      this.searchHistory = newSearchHistory
      sessionStorage.setItem('search_history', JSON.stringify(newSearchHistory))
    },

    doSearchOnEnter () {
      this.searchProducts()
      this.searchMarketingMaterials()
      this.searchNewsAndArticles()
      this.searchSupport()
    },

    onSearchType () {
      clearTimeout(this.searchTimer)
      if (this.searchValue?.length >= 3) {
        this.searchTimer = setTimeout(() => {
          this.storeSearchHistory()
          this.doSearch()
        }, 1500)
      } else {
        this.initSearch()
      }
    },
    onSearchEnter () {
      clearTimeout(this.searchTimer)
      this.storeSearchHistory()
      this.doSearch()
    },
    onSearchReset () {
      this.searchValue = ''
      this.resetSearch()
    },
    resetSearch () {
      this.searchKeyword = ''
      this.resetQuery()
      this.searchProducts(this.searchKeyword)
      this.searchMarketingMaterials(this.searchKeyword)
    },
    resetQuery () {
      const queries = {
        sort: { catalog_product_name: 'ASC' },
        search: '',
        category_uid: [],
        brand: [],
        sub_brand: [],
        filter_packaging: [],
        type: [],
        material_type: [],
        price: [],
        volume: []
      }
      this.$store.commit('catalog/SET_QUERIES', {
        ...queries
      }, { root: true })
    },

    doSearch () {
      const tabName = this.tabs[this.currentTab].name.toLowerCase().replace(' ', '-')
      if (tabName === 'products') {
        this.searchProducts()
      } else if (tabName === 'marketing-materials') {
        this.searchMarketingMaterials()
      } else if (tabName === 'news-and-articles') {
        this.searchNewsAndArticles()
      } else if (tabName === 'support') {
        this.searchSupport()
      }
    },

    initSearch () {
      if (this.searchHistory?.length > 0) {
        this.searchKeyword = this.searchHistory[0]
      } else {
        this.searchKeyword = ''
      }
      this.searchProducts(this.searchKeyword)
      this.searchMarketingMaterials(this.searchKeyword)
    },
    searchMarketingMaterials (keyword?: string) {
      this.loading = true
      this.$store.dispatch(
        FilesActionType.FETCH_MATERIALS_SEARCH,
        {
          searchTextTitle: this.searchValue?.length >= 3 ? this.searchValue : (keyword || '')
        },
        { root: true }
      )
      this.loading = false
    },
    async searchProducts (keyword?: string) {
      this.loading = true
      try {
        let filter = {}
        if (this.isOnTradeCustomer) {
          filter = { material_type: 'GLASSWARE' }
        }
        await this.$store.dispatch('catalog/FETCH_PRODUCTS', {
          search: this.searchValue?.length >= 3 ? this.searchValue : (keyword || ''),
          currentPage: 1,
          bypassloading: true,
          ...filter
        }, { root: true })
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    searchNewsAndArticles () {
      this.loading = true
      this.$store.state.auth.user.isLoggedIn
        ? this.$store.dispatch(
          ArticlesActionType.SEARCH_ARTICLES,
          {
            searchTextTitle: this.searchValue
          },
          { root: true }
        )
        : this.$store.dispatch(
          ArticlesActionType.FETCH_ARTICLES_PUBLIC,
          {
            searchTextTitle: this.searchValue
          },
          { root: true }
        )
      this.loading = false
    },
    searchSupport () {
      this.loading = true
      this.$store.dispatch(
        SupportActionType.FETCH_NEW_ALL_KBS_ASYNC,
        {
          searchTextTitle: this.searchValue
        },
        { root: true }
      )
      this.$store.dispatch(
        SupportActionType.FETCH_NEW_ALL_FAQ_PAGES,
        {
          searchTextTitle: this.searchValue
        },
        { root: true }
      )
      this.loading = false
    },

    isCreateAnOrder (name: string) {
      return name === 'Create an order' || name === 'Złóż zamówienie'
    },
    goToFavourites () {
      this.$router.push({ path: '/catalog/favorites', replace: true })
    },

    isExternal (url: string) {
      return url?.includes('http')
    },

    hideModal () {
      const menuModalNav = document.getElementById('menuModalNav')
      Modal.getInstance(menuModalNav).hide()
    },
    async handleLogout () {
      await this.$store.dispatch('logout')
      this.isLoading = false
      this.$navigate('/login')
    },
    navLogOut () {
      this.userLogout()
      this.hideModal()
    },
    async userLogout () {
      this.isLoading = true
      sessionStorage.removeItem('uid')
      sessionStorage.removeItem('imp_usr')
      sessionStorage.removeItem('isFromFavoritePage')
      const params = {
        UID: this.currentUser.UID,
        callback: this.handleLogout
      }
      await window.gigya.accounts.logout(params)
    },

    handleMenuClick (item: FooterLink) {
      if (item.name === 'Logout') {
        this.userLogout()
        this.hideModal()
      } else if (item?.name === 'Szkolenia 2') {
        window.gigya.fidm.saml.initSSO({
          spName: this.getSPName(item?.name),
          redirectURL: item.href
        })
      } else if (item?.name === 'Beercoin 10') {
        window.open(constants.gigyaConfig.ssoRedirectURL)
      }
    },

    getSPName (name: string) {
      let spName = ''
      if (name === 'Szkolenia 2') {
        spName = 'eLearning'
      }
      if (name === 'Beercoin 10') {
        spName = 'beercoin'
      }
      return spName
    },
    toggleAccordion (event: any, index: number) {
      if (event?.target?.tagName !== 'A') {
        const menuCollapseNav = document.getElementById('asahi-bs-nav-accordion-collapse-' + index)
        Collapse.getOrCreateInstance(menuCollapseNav).toggle()
        event?.target?.classList.toggle('collapsed')
        event?.target?.setAttribute('aria-expanded', event?.target?.classList.contains('collapsed') ? 'false' : 'true')
      }
    },
    onSearch () {
      this.searchInputActive = true
    },
    toggleModal () {
      this.showModal = !this.showModal
    },
    toggleDropdown () {
      this.openDropdown = !this.openDropdown
    },
    toggleOpenCart () {
      this.openCart = !this.openCart
    },
    async removeProductFromCart (productId: string) {
      try {
        const store = this.$store // Assicurati che lo store sia corretto
        if (store.state.basket?.id && productId) {
          await store.dispatch('basket/REMOVE_ITEM', {
            cart_id: store.state.basket.id,
            cart_item_id: productId
          }, { root: true })
          await store.dispatch('basket/FETCH_MIN_CART_QUERY_FOR_CATALOG', { cart_id: store.state.basket.id }, { root: true })
        }
      } catch (error) {
        console.error('Failed to remove product from cart:', error)
      }
    },
    queries () {
      return this.$store.state.catalog.queries
    },
    updateSearchValue (value: { target: { value: any } }) {
      console.error(value)
      const query = {
        ...this.queries,
        search: value?.target?.value
      }
      this.$store.commit('catalog/SET_QUERIES', query, { root: true })
      this.$store.dispatch('catalog/FETCH_PRODUCTS', query, { root: true })
    },
    async removeAllCartItems () {
      if (!this.id || this.id === '') {
        await this.$store.dispatch('basket/FETCH_BASKET_ID', {}, { root: true })
      }
      await this.$store.dispatch('basket/REMOVE_ALL_ITEMS', { cart_id: this.id }, { root: true })
      await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
    },
    updateCompanyName (selectedCompanyName: any) {
      this.CompanyName = selectedCompanyName
      localStorage.setItem('selectedCompanyName', selectedCompanyName)
    },
    fetchPortalPageMenuLink () {
      const customerType = localStorage.getItem('customertype')
      this.$store.dispatch(LinksActionType.FETCH_PAGE_MENU_LINK, {
        CustomerType: customerType
      })
    },
    refresh () {
      this.$store.commit('basket/SET_PROGRESS_BAR', this.progressBarMessage)
    }
  },
  mounted () {
    this.refresh()
  },
  watch: {
    activeLanguage (newLang, oldLang) {
      if (newLang !== oldLang) {
        this.fetchPortalPageMenuLink()
      }
    }
  }
})
